import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, Outlet } from "react-router-dom";
import { Role } from "../../generated/graphql";
import { RootState } from "../../store";
import ErrorBoundary from "../ErrorBoundaries";
import CHWBottomNav from "../Navs/ChwBottomNav";
import MinorBottomNav from "../Navs/MinorBottomNav";
import PatientBottomNav from "../Navs/PatientBottomNav";
import PractitionerBottomNav from "../Navs/PractitionerBottomNav";

interface props {
  children: JSX.Element;
}

export default function AppLayout() {
  const navigate = useNavigate();
  const [show, setshow] = useState(false);
  const loggedInRole = useSelector(
    (state: RootState) => state.loggedInUser.role
  );
  const loggedInUser = useSelector(
    (state: RootState) => state.loggedInUser.data
  );

  useEffect(() => {
    setshow(false);
    if (!loggedInUser?.id || !loggedInRole) {
      return navigate("/");
    }
    setshow(true);
  }, [loggedInUser, loggedInRole]);

  if (!show) {
    return null;
  }

  let urlArray = window.location.href.split('/');
  let lastUrl = urlArray.pop()

  return (
    <div style={{ fontFamily: "Airbnb Cereal App" }}>
      <div className="relative">
        <div className="overflow-y-auto h-screen pb-10">
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </div>
        {loggedInRole === Role.Chw ? (
          <CHWBottomNav display={lastUrl === 'settings'} />
        ) : loggedInRole === Role.Practitioner ? (
          <PractitionerBottomNav display={lastUrl === 'settings'} />
        ) : loggedInRole === Role.Minor ? (
          <MinorBottomNav display={lastUrl === 'settings'} />
        ) : (
          <PatientBottomNav display={lastUrl === 'settings'} />
        )}
      </div>
    </div>
  );
}
